import React from 'react';
import './footer.css';

function Footer(props) {
    return(
        <footer>
            <hr/>
            <ul className="footer-menu">
                {
                    props.menu.map(item => 
                        <li>{item.title}</li>
                    )
                }
            </ul>
            <p className="copyright">Copyright © 2020 CodeSquire </p>
        </footer>
    );
}

export default Footer;